import { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import { CartProvider, useCart } from "@/contexts/CartContext";
import { usePublicStore } from "./hooks/usePublicStore";
import CartFab from "./components/CartFab";
import CartHydrator from "./components/CartHydrator";
import { paymentMethodIdsFromGraphql } from "@/lib/paymentMethods/graphql";

function StorefrontCartShell({ whatsappPhone }: { whatsappPhone: string | null }) {
  const { storeSlug } = useParams<{ storeSlug: string }>();
  const { syncStore } = useCart();
  const { store: publicStore } = usePublicStore(storeSlug);

  useEffect(() => {
    if (publicStore) {
      syncStore(publicStore.slug, publicStore.id);
    }
  }, [publicStore, syncStore]);

  if (!publicStore) return <Outlet />;

  return (
    <>
      <Outlet />
      <CartFab
        phone={whatsappPhone}
        storeName={publicStore.name}
        cartMessageTemplate={publicStore.whatsappCartMessageTemplate}
        acceptedPaymentMethods={paymentMethodIdsFromGraphql(publicStore.acceptedPaymentMethods)}
      />
    </>
  );
}

export default function StorefrontLayout() {
  const { storeSlug } = useParams<{ storeSlug: string }>();
  const { store, loading } = usePublicStore(storeSlug);

  return (
    <CartProvider key={storeSlug}>
      {storeSlug ? <CartHydrator storeSlug={storeSlug} /> : null}
      {loading && !store ? (
        <Outlet />
      ) : (
        <StorefrontCartShell whatsappPhone={store?.whatsappPhone ?? null} />
      )}
    </CartProvider>
  );
}
